import React from 'react';
import { useSelector } from 'react-redux';
import Spinner from './UI/Spinner';
import Currency from './UI/Currency';
import { selectUserBalance, selectWalletLoading } from '@/store/wallet/selectors';
import { selectUserCurrency } from '@/store/selectors/userSelectors';

function TotalBalance() {
  const balance = useSelector(selectUserBalance);
  const currency = useSelector(selectUserCurrency);
  const walletLoading = useSelector(selectWalletLoading);

  if (walletLoading) {
    return <Spinner height={16} width={16} borderwidth={3} margin="0" color="white" />;
  }
  return (
    <div className="text-sm font-semibold">
      <Currency currency={currency ?? ''} amount={balance} />
    </div>
  );
}

export default TotalBalance;
